export default {
    socials: [],
    contacts: [],
}
